module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(!_vm.isDiscounted) ? _c('span', {
    class: 'price'
  }, [_vm._v("\n    " + _vm._s(_vm._f("currency")(_vm.priceOriginal)) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.isDiscounted) ? _c('span', {
    class: 'price price--discounted'
  }, [_c('span', {
    staticClass: "price--original"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.priceOriginal)))]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "price--discounted"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.priceDiscounted)))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26ca5218"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/PriceView.vue
// module id = 910
// module chunks = 0